/**
 * Zero-width space character used to mark the start of an email signature
 */
export const SIGNATURE_MARKER = "\u200B";

/**
 * HTML entity version of the signature marker for use in HTML content
 */
export const SIGNATURE_MARKER_TAG = "<p>&#x200B;</p>";

/**
 * Strips the email signature from text content.
 * Removes everything after the signature marker and cleans up trailing newlines.
 *
 * @param textContent The text content that may contain a signature
 * @returns The text content with the signature removed
 */
export function stripSignature(textContent: string): string {
  const signatureIndex = textContent.indexOf(SIGNATURE_MARKER);
  if (signatureIndex === -1) {
    return textContent;
  }

  let result = textContent.substring(0, signatureIndex) + "\n";

  // Remove up to 2 trailing newlines
  let newlinesToRemove = 2;
  while (result.endsWith("\n\n") && newlinesToRemove > 0) {
    result = result.substring(0, result.length - 1);
    newlinesToRemove--;
  }

  return result;
}
